module.exports = __webpack_public_path__ + "img/CeeYuu_Logo_weiss_1200x304.1a2df60e.png";